import moment from 'moment';
import { DEFAULT_STAT_LIMIT } from '../common/config';
import { Filter } from '../common/filter';

class FilterDataService {
  constructor({
                CurrentFilterService,
                CurrentModelService,
                $q,
                $rootScope,
                $http,
                ErrorHandlerService,
                rx,
              }) {
    this.CurrentFilterService = CurrentFilterService;
    this.CurrentModelService = CurrentModelService;
    this.$q = $q;
    this.$rootScope = $rootScope;
    this.$http = $http;
    this.ErrorHandlerService = ErrorHandlerService;

    this.filter = null;
    this.actualFilter = null;
    this.filterData = null;
    this.loading = false;
    this.loadingMore = false;
    this.cancelled = false;
    this.cancelledMore = false;
    this.canceller = null;
    this.frameLoad = null;
    this.cancelSubject = new rx.Subject();
    this.loadMoreSubject = new rx.Subject();
    this.filterSubject = new rx.Subject();
    this.loadingSubject = new rx.Subject();
    this.loading$ = this.loadingSubject.asObservable();
    this.filterData$ = this.filterSubject.asObservable()
      .filter(() => {
        if (!this.CurrentModelService.cube) {
          console.error('model is not defined');
          return false;
        }
        return true;
      })
      .map((filter) => {
        if (!filter) {
          return null;
        }
        this.filter = filter;
        this.actualFilter = this.getActualFilter(filter);
        return {
          filter: this.actualFilter,
          url   : this.getUrl(this.actualFilter),
          params: this.actualFilter.buildQueryParams(),
        };
      })
      .distinctUntilChanged(null, (params1, params2) => {
        return !this.cancelled && params1 && params2 &&
          !(params1.filter.isReports() && params2.filter.isReports()) &&
          params1.url === params2.url &&
          angular.equals(params1.params, params2.params);
      })
      .filter(params => params)
      .switchMap((params) => {
        if (this.loading || this.loadingMore) {
          this.onCancel();
        }
        this.filterData = null;
        this.page = 0;
        params.params.page = this.page;
        this.beforeLoad();
        let loadPromise = this.load(params);
        this.loadingSubject.onNext(true);
        return rx.Observable.amb(
          this.cancelSubject.asObservable()
            .do(() => this.onCancel())
            .first(),
          rx.Observable.fromPromise(loadPromise)
            .do((data) => this.afterLoad(data))
            .catch((error) => {
              this.onError(error);
              this.error = error;
              return rx.Observable.of(null);
            }),
        )
          .flatMap((data) => {
              this.loadingSubject.onNext(false);
              if (data === null) {
                return rx.Observable.of(data);
              }
              if (!this.filter.isExplore()) {
                return rx.Observable.of(data);
              }
              return rx.Observable.of(data)
                .concat(this.loadMoreSubject.asObservable()
                  .exhaustMap(() => rx.Observable.of(null).flatMap(() => {
                      if (this.isComplete) {
                        return rx.Observable.of(null);
                      }
                      this.page = this.page + 1;
                      let nextPageParams = {
                        filter: params.filter,
                        url   : params.url,
                        params: Object.assign({}, params.params),
                      };
                      nextPageParams.params.page = this.page;
                      this.beforeLoad();
                      return rx.Observable.amb(
                        this.cancelSubject.asObservable()
                          .do(() => this.onCancel())
                          .first(),
                        rx.Observable.fromPromise(this.load(nextPageParams))
                          .do((data) => this.afterLoad(data))
                          .catch((error) => {
                            this.onError(error);
                            return rx.Observable.of(null);
                          }),
                      );
                    }),
                  ),
                );
            },
          );
      })
      .share()
    ;
    this.subscription = this.filterData$
      .subscribe(
        () => {
          this.$rootScope.$evalAsync(() => {
          });
        },
      );
  }

  update(filter, force) {
    let result = this.filterData$.first().toPromise();
    if (force) {
      this.filterSubject.onNext(null);
    }
    this.filterSubject.onNext(filter);
    return result;
  }

  moreFacts() {
    this.loadMoreSubject.onNext(null);
  }

  load({filter, url, params}) {
    if (filter.isReports() && !filter.isCard) {
      this.frameLoad = this.$q.defer();
      return this.frameLoad.promise;
    }
    return this.$http.get(url, {
      params : params,
      timeout: this.canceller.promise,
    }).then(({data}) => data);
  }

  getActualFilter(filter) {
    let actualFilter = new Filter('Facts');
    actualFilter.copyFrom(filter);
    actualFilter.timeFrom = this.CurrentFilterService.timeFrom;
    actualFilter.timeTo = this.CurrentFilterService.timeTo;
    if (filter.isExplore()) {
      actualFilter.order = 'local_time';
    } else if (filter.isReport()) {
      let days = moment(actualFilter.timeTo)
        .diff(moment(actualFilter.timeFrom), 'days') + 1;
      if (days < 1) days = 1;
      actualFilter.days = days;
      let activity_dimension;
      if (days > 1) {
        activity_dimension = 'agent_time@ymdh:hour';
        actualFilter.drilldown = [activity_dimension];
        actualFilter.limit = days * 24;
      } else {
        activity_dimension = 'agent_time@ymdhm:minute';
        actualFilter.drilldown = [activity_dimension];
        actualFilter.limit = 24 * 60;
      }
      actualFilter.setOrder(activity_dimension);
    } else if (filter.isStat() || filter.isChartArea() ||
      filter.isChart() || filter.isTree()) {
      actualFilter.order = filter.measure;
      actualFilter.orderDir = 'desc';
      actualFilter.timePeriod = this.CurrentFilterService.timePeriod;
      actualFilter.limit = DEFAULT_STAT_LIMIT;
    } else if (filter.isCard) {
      actualFilter.order = filter.measure;
      actualFilter.orderDir = 'desc';
      actualFilter.timePeriod = this.CurrentFilterService.timePeriod;
      actualFilter.limit = DEFAULT_STAT_LIMIT;
    } else if (filter.isReports()) {
    } else {
      console.error('unknown filter mode');
    }
    return actualFilter;
  }

  getUrl(filter) {
    if (filter.isExplore()) {
      return '/analytics/facts/' + this.cube.name + '/';
    } else if (filter.isReport() || filter.isStat() || filter.isChartArea() ||
      filter.isChart() || filter.isTree()) {
      return filter.skipStat ?
        '/analytics/values/' + this.cube.name + '/' :
        '/analytics/aggregate/' + this.cube.name + '/';
    } else if (filter.isCard) {
      return '/analytics/card/';
    } else if (filter.isReports()) {
      return filter.url;
    }
    console.error('unknown filter mode');
  }

  formatDate(text) {
    return Filter.formatDate(new Date(text), 'dd MMM yyyy HH:mm');
  }

  get cube() {
    return this.CurrentModelService.cube;
  }

  cancel() {
    this.cancelSubject.onNext(null);
  }

  onCancel() {
    if (!this.loading && !this.loadingMore || !this.canceller) {
      console.error('nothing to cancel');
      return;
    }
    this.canceller.resolve('abort');
    this.canceller = null;
    this.loading = false;
    this.loadingMore = false;
    this.isComplete = false;
    this.frameLoad = null;
    if (this.page > 0) {
      this.page = this.page - 1;
      this.cancelledMore = true;
    } else {
      this.cancelled = true;
    }
    this.$rootScope.$evalAsync(() => {
    });
    // console.log('cancel filter page', this.page);
  }

  beforeLoad() {
    if (this.loading || this.loadingMore || this.canceller) {
      console.error('load filter already in progress');
    }
    this.canceller = this.$q.defer();
    this.loading = this.page === 0;
    this.loadingMore = this.page !== 0;
    this.cancelled = false;
    this.cancelledMore = false;
    this.isComplete = false;
    this.error = null;
    this.$rootScope.$evalAsync(() => {
    });
    // console.log('load filter page', this.page);
  }

  afterLoad(data) {
    if (!this.loading && !this.loadingMore) {
      console.error('load filter not in progress');
    }
    this.loading = false;
    this.loadingMore = false;
    this.canceller = null;
    this.frameLoad = null;
    if (this.page === 0) {
      if (this.filter.isExplore()) {
        this.isComplete = data.object_list.length < this.filter.limit;
        this.filterData = data.object_list;
      } else {
        this.isComplete = true;
        this.filterData = data;
        if (this.filter.isReport() || this.filter.isStat() || this.filter.isChartArea() ||
          this.filter.isChart() || this.filter.isTree()) {
          data.filter = this.actualFilter;
        } else if (this.filter.isCard) {
          data.items = data.items || [];
          for (let i = 0; i < data.items.length; ++i) {
            const item = data.items[i];
            item['agent_account.last_report_time'] =
              this.formatDate(item['agent_account.last_report_time']);
            item['agent_account.last_activity_time'] =
              this.formatDate(item['agent_account.last_activity_time']);
          }
        }
      }
    } else {
      if (this.filter.isExplore()) {
        this.isComplete = data.object_list.length < this.filter.limit;
        this.filterData = this.filterData.concat(data.object_list);
      } else {
        this.isComplete = true;
        this.filterData = data;
      }
    }
    // this.$rootScope.$evalAsync(() => {
    // });
    this.$rootScope.$digest();
    // console.log('done filter page', this.page);
  }

  onError(error) {
    this.loading = false;
    this.loadingMore = false;
    this.canceller = null;
    this.isComplete = false;
    this.frameLoad = null;
    if (this.page > 0) {
      this.page = this.page - 1;
    }
    this.ErrorHandlerService.handle(error);
    this.$rootScope.$evalAsync(() => {
    });
    console.error('load filter page', this.page, error);
  }
}

export function FilterDataFactory(
  CurrentFilterService,
  CurrentModelService,
  $q,
  $rootScope,
  $http,
  ErrorHandlerService,
  rx,
) {
  return () =>
    new FilterDataService({
      CurrentFilterService,
      CurrentModelService,
      $q,
      $rootScope,
      $http,
      ErrorHandlerService,
      rx,
    });
}



// WEBPACK FOOTER //
// ./src/core/filter-data.factory.js